import { useState, useCallback } from 'react';
import { useAtomValue } from 'jotai';
import { userInfoAtom } from '@/data/atoms/utilsAtoms';

const useAdminAnalytics = () => {
  const [loading, setLoading] = useState(false);
  const [analytics, setAnalytics] = useState(null);
  const [filterOptions, setFilterOptions] = useState({ userEmails: [], categories: [] });
  const userData = useAtomValue(userInfoAtom);

  const getGlobalAnalytics = useCallback(async (filters = {}) => {
    
    setLoading(true);
    const queryParams = new URLSearchParams();
      Object.entries(filters).forEach(([key, value]) => {
        if (value) queryParams.append(key, value);
      });

      const url = `${import.meta.env.VITE_APP_API_URL}/admin/analytics/global-analytics?${queryParams}`;
      
      const response = await fetch(url, {
        headers: {
          'Authorization': `Bearer ${userData.token}`
        }
      });
      
      const result = await response.json();
      setAnalytics(result.data);
      setLoading(false);
      return result.data;
  }, [userData.token]);

  const getFilterOptions = useCallback(async () => {
    const response = await fetch(`${import.meta.env.VITE_APP_API_URL}/admin/analytics/filters`, {
        headers: {
          'Authorization': `Bearer ${userData.token}`
        }
      });

      const result = await response.json();
      
      if (result.success) {
        setFilterOptions(result.data);
      }
      return result.data;
  }, [userData.token]);

  return {
    analytics,
    filterOptions,
    loading,
    getGlobalAnalytics,
    getFilterOptions
  };
};

export default useAdminAnalytics;